import { NextLineIcon } from 'canoe';
import React from 'react';

import { ValueToggle } from '@candu-ai/craft/ui';

interface Props {
  flexWrap?: string;
  setCss: (css: Record<string, any>) => void;
}

export const FlexWrap = ({ flexWrap, setCss }: Props) => {
  return (
    <ValueToggle
      toggleGroup="flex-wrap"
      id="wrap"
      data-cy="toolbox-flex-wrap"
      onClick={() =>
        setCss({
          flexWrap: 'wrap',
        })
      }
      isActive={flexWrap === 'wrap'}
      icon={NextLineIcon}
      tooltip="Wrap"
      color="light"
    />
  );
};
